export const MSG_UNKNOWN_ERROR =
  '요청사항을 처리하는데 실패했습니다. 잠시 후 다시 시도해주세요.';
export const DEFAULT_MSG_TICKET_NOT_ENOUGH =
  '이용권이 부족합니다.\n이용권 충전 화면으로 이동하시겠습니까?';
export const MSG_ITEM_NOT_SALE =
  '죄송합니다.\n현재 해당 상품을 판매하고 있지 않아서\n이용하실 수 없습니다.';
export enum RestrictUserType {
  Login = 'LOGIN',
}
export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd hh:mm:ss';
